import * as Yup from "yup";
import moment from "moment";

const recordSchema = Yup.object({
  startDate: Yup.date()
    .max(
      moment().add(-1, "days"),
      "StartingOn Date cannot be today or greater than today."
    )
    .required("StartingOn Date is required"),
  endDate: Yup.date()
    .max(
      moment().add(-1, "days"),
      "EndingOn Date cannot be today or greater than today."
    )
    .min(Yup.ref("startDate"), "End date must be grater than start date")
    .required("EndingOn Date is required"),
});

const missingPunchesSchema = Yup.object({
  punchfor: Yup.string().required("Punch is required"),
  punchtype: Yup.string().required("Punch type  is required"),
  missingdate: Yup.date()
    .max(
      moment().add(-1, "days"),
      "Date cannot be today or greater than today."
    )
    .required("Date is required"),
  time: Yup.string().required("Time is required"),
});

export { recordSchema, missingPunchesSchema };
